<template>
    <CustomHeader :text="$t('bonus.mysterybonus')" />

    <div class="bonus_container">
        <img :src="dataSet.bannerIcon" alt="">

        <div class="day_row">
            <div v-for="(item, index) in dataSet.dayList" :key="index" @click="selectTab(item, index)">
                <div class="day_card">
                    <div class="content"
                        :style="{ background: item.reward_day == dataSet.selectedTab.reward_day ? 'linear-gradient(180deg, #ff3d9e, #fd66b1)' : '' }">
                        <img :src="mysterioImages[index].img" alt="" width="50%">
                        <div class="date_text">
                            {{ $t('common.travel') }} <span>{{ item.reward_day }}</span></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div style="padding: 15px; margin-top: -10%;">
                <transition :name="swipeName">

        <div class="details_card" v-if="dataSet.selectedTab" :key="selectedTabIndex">
            <van-row class="details_content">
                <van-col span="24">
                    <van-row class="topCard">
                        <van-col span="12" class="label_text">{{ $t('bonus.registrationTime') }}</van-col>
                        <van-col span="12" class="value_text">{{
                            formatUnixTimestamp(dataSet.mysteryDataConfig?.config?.user_join_date)
                        }}</van-col>
                        <van-col span="15" class="label_text">{{ $t('bonus.totalDeposit') }} <span>{{
                            dataSet.selectedTab?.reward_day
                                }}</span>
                            {{ $t('common.days') }}:</van-col>
                        <van-col span="9" class="value_text" style="color: #ffcb52;">R${{
                            formatCurrency(dataSet.selectedTab?.reward_data?.rechargeCoin || 0)
                        }}</van-col>
                    </van-row>
                </van-col>
                <van-col :span="2" class="arrowImage" style="transform: rotate(180deg);">
                    <img src="@/assets/themetwo/arr.png" style="height: 30px;width: 30px;" @click="selectTab((selectedTabIndex - 1) < 0 ? dataSet.dayList[dataSet.dayList.length - 1] : dataSet.dayList[selectedTabIndex - 1], (selectedTabIndex - 1) < 0 ? dataSet.dayList.length - 1 : selectedTabIndex - 1)">
                </van-col>
                <van-col :span="20" class="middleImage">
                    <img :src="mysterioImages[selectedTabIndex].img" style="height: 150px;width: 150px;z-index: 1;"
                        alt="" width="100%">
                    <img src="@/assets/themetwo/base.png" class="baseImg" style="height: 72px;width: 222px;" alt=""
                        width="100%">
                </van-col>
                <van-col :span="2"  class="arrowImage">
                    <img src="@/assets/themetwo/arr.png" style="height: 30px;width: 30px;" @click="selectTab((selectedTabIndex + 1) > dataSet.dayList.length - 1 ? dataSet.dayList[0] : dataSet.dayList[selectedTabIndex + 1], (selectedTabIndex + 1) > dataSet.dayList.length - 1 ? 0 : selectedTabIndex + 1)">
                </van-col>
                <van-col span="24">
                    <van-row class="middleCard">
                        <van-col span="24" class="text_1">
                            {{ $t('bonus.claimTime') }}
                        </van-col>
                        <van-col span="24">
                            <div class="date_details">
                                {{ formatUnixTimestamp(dataSet.selectedTab?.reward_data?.rewardTime) }}
                            </div>
                        </van-col>
                        <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0" span="24"
                            class="misterio_text">
                            {{ $t('bonus.mysterybonus') }}
                        </van-col>
                        <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 || dataSet.selectedTab?.reward_data?.activeStatus === 1 && dataSet.selectedTab?.reward_data?.rewardCoin" span="24" class="amount">R$
                            <span
                                :style="{ color: dataSet.selectedTab?.reward_data?.rewardCoin > 0 ? '#ffcb52' : '#ffcb52' }">
                                {{ formatCurrency(dataSet.selectedTab?.reward_data?.rewardCoin || 0) }}</span></van-col>
                        <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 2 ||  (dataSet.selectedTab?.reward_data?.activeStatus === 1 && !dataSet.selectedTab?.reward_data?.rewardCoin)" span="24" class="misterio">
                            <img src="@/assets/bonus/weikaishi_tu.png" alt="">
                        </van-col>
                    </van-row>
                </van-col>
                <!-- Expired -->
                <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 && !dataSet.selectedTab?.reward_data?.rewardCoin" span="24" class="start_img"><img
                        src="@/assets/bonus/smactv2_btn_expire.png" alt=""></van-col>

                <!-- Previous claimed -->
                 <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 0 && dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="statusBar" style="color:#66d329">
                    {{ $t('activityStatus.completed') }}
                </van-col>
                <!-- Today not claimed -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 1 && !dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="start_img2"><img src="@/assets/bonus/smactv2_btn_notstart.png" alt=""
                        :class="{ 'pop-animate': dataSet.isPopping }"
                        @click="pickMisteryGift(dataSet.selectedTab?.reward_data?.activeStatus)"></van-col>

                <!-- Today claimed -->
                <van-col
                    v-if="dataSet.selectedTab?.reward_data?.activeStatus === 1 && dataSet.selectedTab?.reward_data?.rewardCoin"
                    span="24" class="statusBar" style="color:#66d329">
                    {{ $t('activityStatus.completed') }}
                </van-col>
                <!-- Upcoming -->
                <van-col v-if="dataSet.selectedTab?.reward_data?.activeStatus === 2" span="24" class="statusBar"
                    style="color:#f8d8a7">
                    {{ $t('rewards.notActivated') }}
                </van-col>
            </van-row>
        </div>
                </transition>

    </div>
    <div class="tabel_container" v-if="dataSet.selectedTab">
        <van-row class="tabel_hed">
            <van-col span="11" class="head_alignemnet">{{ $t('bonus.depostiScope') }}</van-col>
            <van-col span="2" class="head_alignemnet">
                <div class="line"></div>
            </van-col>
            <van-col span="11" class="head_alignemnet">{{ $t('bonus.mysterybonus') }}</van-col>
        </van-row>
        <van-row class="tabel_row" v-for="(item, index) in dataSet.selectedTab?.reward_data?.reward_day_data"
            :key="index" :style="{
                backgroundColor: '#312734',
                borderRadius: index === dataSet.selectedTab?.reward_data?.reward_day_data.length - 1 ? '0px 0px 10px 10px' : ''
            }">
            <van-col span="12" class="head_alignemnet">R$
                <span>{{ item.recharge_min < 0 ? '\u221E' : formatCurrency(calculateValue(item.recharge_min)) }} ~ {{
                    item.recharge_max < 0 ? '\u221E' : formatCurrency(calculateValue(item.recharge_max)) }} </span>
            </van-col>
            <van-col span="12" class="head_alignemnet currencyText">R$
                <span style="color: #ffcb52; font-size: 14px;">{{ item.show_reward_min < 0 ? '\u221E' :
                    formatCurrency(calculateValue(item.show_reward_min)) }} ~ {{ item.show_reward_max < 0 ? '\u221E'
                            : formatCurrency(calculateValue(item.show_reward_max)) }} </span></van-col>
        </van-row>
    </div>
    <div class="bottom_text" v-if="dataSet.activityInfo.length > 0">
        <van-row style="padding-bottom: 10px;">
            <!-- <van-col span="6" class="">
                <div class="line1"></div>
            </van-col> -->
            <van-col span="24" class="title">
                <div>{{ $t('common.activityTitle') }}</div>
            </van-col>
            <!-- <van-col span="6" class="">
                <div class="line2"></div>
            </van-col> -->
        </van-row>
        <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
            {{ item }}
        </div>
    </div>
</template>
<script setup lang="ts">
import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { defineProps, ref, defineEmits, onMounted, watch } from 'vue';
import { BonusData, calculateValue, MYSTERIO_IMG_THEME_TWO } from '@/view/bonus/supportScript';
import CustomHeader from '../components/common/customHeader.vue';

const mysterioImages = ref(MYSTERIO_IMG_THEME_TWO)
const selectedTabIndex = ref(0)
const swipeName = ref('swipe-left') 
const props = defineProps<{
    dataSet: BonusData
}>()

const emits = defineEmits(['pickMisteryGift', 'selectTab'])

const pickMisteryGift = (activeStatus: number) => {
    emits('pickMisteryGift', activeStatus)
}

const selectTab = (item: any, index: number) => {
     if (index > selectedTabIndex.value) {
        swipeName.value = 'swipe-left'
    } else if (index < selectedTabIndex.value) {
        swipeName.value = 'swipe-right'
    }
    selectedTabIndex.value = index
    emits('selectTab', item)
}

function syncSelectedIndex() {
    if (!props.dataSet || !props.dataSet.dayList || !props.dataSet.selectedTab) return
    const idx = props.dataSet.dayList.findIndex(item => item.reward_day === props.dataSet.selectedTab.reward_day)
    if (idx >= 0) selectedTabIndex.value = idx
}

onMounted(() => {
    syncSelectedIndex()
})

watch(() => props.dataSet, (val) => {
    if (val) syncSelectedIndex()
}, { immediate: true })
</script>
<style scoped>
.bonus_container {
    padding: 60px 0 0;
    position: relative;
}

.day_row {
    padding: 0 15px;
    position: absolute;
    bottom: 10%;
    display: flex;
    flex-direction: row;
}

.bonus_container img {
    width: 100%;
}

.day_card {
    position: relative;
    margin: 0 2.5px;
}

.day_card img {
    width: 100%;

}

.giftCard {
    background-image: url('@/assets/themetwo/Box5_close.png');
    height: 100px;
}

.content {
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center; */
    /* background: red; */
    border: .03rem solid #65426f;
    border-radius: 10px;
    color: #fff;
    flex-direction: column;

}

.logo img {
    width: 60px;
}

.date_text {
    font-size: 13px;
    color: #fff;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    margin-top: -10px;
    background-color: #8d4d9e;
    border-radius: 0px 0px 10px 10px;
    padding: 4px 0px;
}

.date_text span {
    /* font-size: 20px; */
    padding-left: 5px;
}

.select_icon {
    display: flex;
    justify-content: center;
}

.select_icon img {
    width: 18px;
    padding-top: 10px;
}

.swipe-left-enter-from {
    transform: translateX(100%);
    opacity: 0;
}
.swipe-left-enter-active {
    transition: transform 700ms ease, opacity 500ms ease;
}
.swipe-left-enter-to {
    transform: translateX(0);
    opacity: 1;
}
.swipe-left-leave-from {
    transform: translateX(0);
    opacity: 1;
}
.swipe-left-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}

/* swipe right: new content enters from left, old leaves to right */
.swipe-right-enter-from {
    transform: translateX(-100%);
    opacity: 0;
}
.swipe-right-enter-active {
    transition: transform 700ms ease, opacity 500ms ease;
}
.swipe-right-enter-to {
    transform: translateX(0);
    opacity: 1;
}
.swipe-right-leave-from {
    transform: translateX(0);
    opacity: 1;
}
.swipe-right-leave-to {
    transform: translateX(100%);
    opacity: 0;
}


.details_card {
    /* margin-top: -30px; */
    position: relative;
    background: #33243e;
    border-radius: 15px;
    /* border-bottom: 3px solid #dd7a33;
    border-top: 3px solid #dd7a33; */
    padding: 5px 0 15px;
}

.details_card img {
    width: 100%;
}

.tab_arrow {
    display: flex;
    justify-content: center;
}

.tab_arrow img {
    width: 25px;
}

.details_content {
    padding: 0 25px;
}

.details_content img {
    width: 20px;
    padding: 5px 0;
}

.middleImage {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.giftBoxImg {
    height: 150px;
    width: 150px;
    z-index: 1;
}

.baseImg {
    position: absolute;
    bottom: 0;
}

.arrowImage {
    align-items: center;
    display: flex;
}

.label_text {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.65);
    font-size: 3.6vw;
}

.label_text span {
    color: #FFEE00;
    padding: 0 5px;
}

.currencyText {
    color: #ffcb52;
}

.value_text {
    display: flex;
    align-items: center;
    justify-content: right;
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
}

.text_1 {
    color: #86718c;
    font-size: 13px;
    display: flex;
    justify-content: center;
    text-align: center;
    padding: 0px 35px 10px;
}

.middleCard {
    border-radius: 15px;
    padding: 20px;
    background: #2a1632;
    border: .05rem solid #65426f;
    color: #86718c;
}

.topCard {
    border-radius: 15px;
    background: #2a1632;
    border: .05rem solid #65426f;
    color: #86718c;
    padding: 20px;
    margin-bottom: 10px;
}

.date_details {
    color: #a7efff;
    font-weight: bold;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 0px;
}

.date_details img {
    width: 20px;
    padding: 5px;
}

.misterio_text {
    color: #86718c;
    font-weight: bold;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 10px;
}

.misterio_text img {
    width: 20px;
    padding: 5px;
}

.amount {
    color: #ffcb52;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.amount span {
    font-size: 6vw;
    padding: 0 5px;
    color: rgba(0, 0, 0, 0.25);
    font-weight: bold;

}

.start_img {
    display: flex;
    align-items: center;
    justify-content: center;
}

.start_img img {
    width: 310px;
}

.start_img2 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.start_img2 img {
    width: 310px;
}

.misterio {
    display: flex;
    align-items: center;
    justify-content: center;
}

.misterio img {
    width: 40%;
}

.tabel_container {
    /* border: 2px solid #221b24; */
    border-radius: 10px;
    margin: 0 15px;
}

.tabel_hed {
    background: #3f2e4b;
    color: rgba(255, 255, 255, 0.85);
    padding: 15px;
    border-radius: 10px 10px 0px 0px;
    font-size: 16px;
}

.head_alignemnet {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.line {
    width: 1px;
    height: 15px;
    background-color: rgba(255, 255, 255, 0.15);
}

.tabel_row {
    color: #fff;
    padding: 20px;
    font-size: 13px;
}

.tabel_row span {
    padding: 0 5px;
}

.bottom_text {
    padding: 20px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: #7a4289;
    font-size: 15px;
    display: flex;
    justify-content: flex-start;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px 0px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

.statusBar {
    display: flex;
    justify-content: center;
    align-items: center;
    color: green;
    font-weight: bold;
    font-size: 16px;
    background: #0000003b;
    padding: 15px;
    border-radius: 10px;
    margin: 15px 0 10px;

}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

@media(min-width: 400px) {
    .label_text {
        font-size: 13px !important;
    }

    .amount span {
        font-size: 30px !important;
    }
}
</style>